import styled, { keyframes } from 'styled-components';
import { Box } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';

export const pulseKeyframes = keyframes`
    0% {
        background-color: ${colors.grey100}
    }

    30% {
        background-color: ${colors.grey200}
    }

    100% {
        background-color: ${colors.grey100}
    }
`;

const PulsingBox = styled(Box)`
    width: 100%;
    animation: ${pulseKeyframes} 1s infinite 0.2s;
`;

export default PulsingBox;
